import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { SaleEventModel } from "@models/saleEvent/customerModel"

class PaymentScheduleService {
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/PaymentSchedule/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PaymentSchedule/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post(
      "api/services/app/PaymentSchedule/BulkActive",
      id
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PaymentSchedule/Get", {
      params: { id },
    })
    const { result } = res.data
    return SaleEventModel.assign(result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PaymentSchedule/GetAll", {
      params,
    })
    return res.data.result
  }
  public async getList(): Promise<any[]> {
    const res = await http.get("api/services/app/PaymentSchedule/GetList", {
      params: { isActive: true },
    })
    const { result } = res.data
    return result
  }
}

export default new PaymentScheduleService()
